<template>
    <div class="border-l border-r shadow-md relative new-ui">
        <template v-if="preLoading">
            <div class="h-[800px] flex justify-center items-center">
                <preloader/>
            </div>
        </template>
        <div v-else>
            <div v-if="loading"
                 class="absolute flex items-center justify-center w-full h-full bg-gray-100 bg-opacity-50 z-20">
                <spinner/>
            </div>

            <widget-app/>

            <!--            <select-from-storage v-if="checkLocalstorage"/>-->
        </div>

        <template v-if="showHelpPrefill">
            <portal selector="#widget-modal">
                <help-prefetch/>
            </portal>
        </template>
    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";
import dayjs from "dayjs";
import widgetApp from "./components/widget-app";
import preloader from "./components/preloader";
import selectFromStorage from "./components/select-from-storage";
import tippy from "tippy.js";

export default {
    name: "widget",
    components: {
        HelpPrefetch: () => import("./components/modals/help-prefetch"),
        preloader,
        widgetApp,
        selectFromStorage
    },
    computed: {
        preLoading () {
            return this.$store.getters["others/getPreLoading"];
        },
        loading () {
            return this.$store.getters["others/getLoading"] || this.$store.getters["fakeLeads/getLoading"];
        },
        checkLocalstorage () {
            let storage = JSON.parse(localStorage.getItem("widget-store"));
            if (storage) {
                let a = dayjs(storage.expireDate);
                let b = dayjs(Date.now());
                if (a.diff(b, "days") < 10) {
                    return true;
                } else {
                    localStorage.removeItem("widget-store");
                    return false;
                }
            }
            return false;
        }
    },
    data () {
        return {
            showHelpPrefill: false,
            savedList: this.$widgetConfig.savedList || null,
            sharedList: this.$widgetConfig.sharedList || null
        };
    },
    methods: {
        dateFormatUI (config) {
            if (config.day) {
                return "DD MMM, YYYY";
            } else if (config.month) {
                return "MMM, YYYY";
            } else {
                return "YYYY";
            }
        },
        async getConfig () {
            this.$store.commit("others/setPreLoading", true);

            await this.$store.dispatch("widgetData/getConfig");

            if (this.savedList) {
                this.$store.commit("widgetData/loadSelectFromLocalstorage", this.savedList.presets);
                this.$store.commit("widgetData/setUserChanged");
            }

            if (this.sharedList) {
                this.$store.commit("widgetData/loadSelectFromLocalstorage", this.sharedList.presets);
                this.$store.commit("widgetData/setUserChanged");
            }

            if (this.$widgetConfig.prefill_list) {
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.get("audience")) {
                    if (this.$widgetConfig.prefill_help) {
                        this.showHelpPrefill = true;
                    }
                    let activeAudience = this.$store.getters["widgetData/getAudienceDataByCode"](urlParams.get("audience"));
                    for (const [key, value] of urlParams) {
                        if (key === "audience") {
                            this.$store.commit("widgetData/setAudience", value);
                        } else if (key === "preset_code") {
                            this.$store.commit("widgetData/setSubAudience", value);
                        } else if (key.includes("one_per_address_id_widget")) {
                            let xPreSelect = this.$store.getters["widgetData/getXPerSelection"];
                            let valueObj = xPreSelect.values.find(item => item.value === value);
                            this.$store.commit("widgetData/addSelect", {
                                sensitive: xPreSelect.attentionText !== "",
                                code: xPreSelect.code,
                                group: xPreSelect.group,
                                title: `${xPreSelect.title.replace("Number of c", "C")}: ${valueObj.title}`,
                                query: value
                            });
                        } else {
                            let selectFromStore = activeAudience.selections.find(item => item.code === key);
                            if (selectFromStore) {
                                if (selectFromStore.type === "input_range") {
                                    let parseValue = value.split(",");
                                    let sensitive = selectFromStore.attentionText !== "";

                                    if (sensitive) {
                                        sensitive = selectFromStore.code === "b2c_age" && (Number(parseValue[0]) >= 65);
                                    }

                                    this.$store.commit("widgetData/addSelect", {
                                        sensitive,
                                        code: selectFromStore.code,
                                        group: selectFromStore.group,
                                        title: `${selectFromStore.title}: ${Number(parseValue[0])} - ${Number(parseValue[1])}`,
                                        query: [Number(parseValue[0]), Number(parseValue[1])]
                                    });
                                } else if (selectFromStore.type === "checkboxes" || selectFromStore.type === "multi_checkboxes") {
                                    let title = selectFromStore.values.filter(item => value.includes(item.value)).map(item => item.title.charAt(0).toUpperCase() + item.title.toLowerCase().slice(1)).join(", ");
                                    this.$store.commit("widgetData/addSelect", {
                                        sensitive: selectFromStore.attentionText !== "",
                                        code: selectFromStore.code,
                                        group: selectFromStore.group,
                                        title: `${selectFromStore.title}: ${title}`,
                                        query: value.split(",")
                                    });
                                } else if (selectFromStore.type === "date_range") {
                                    let parseValue = value.split(",");

                                    this.$store.commit("widgetData/addSelect", {
                                        sensitive: selectFromStore.attentionText !== "",
                                        code: selectFromStore.code,
                                        group: selectFromStore.group,
                                        title: `${selectFromStore.title}: ${dayjs(parseValue[0]).format(this.dateFormatUI(selectFromStore.config))} - ${dayjs(parseValue[1]).format(this.dateFormatUI(selectFromStore.config))}`,
                                        query: [parseValue[0], parseValue[1]]
                                    });
                                } else if (selectFromStore.type === "tags_autocomplete") {
                                    let params = {
                                        query: value.split(",")
                                    };
                                    if (selectFromStore.code) {
                                        params.code = selectFromStore.code;
                                    }
                                    await this.$store.dispatch("widgetData/getValues", params).then(({ data: { data: response } }) => {
                                        if (!response.length) {
                                            return;
                                        }

                                        let selectStore = this.$store.getters["widgetData/getSelectByCode"](selectFromStore.code);
                                        response.map(item => {
                                            let query = [];
                                            let queryUI = [];
                                            if (selectStore) {
                                                query = selectStore.query;
                                                query.push(item.value);
                                                queryUI = selectStore.queryUI ?? [];
                                                queryUI.push(item.title);
                                            } else {
                                                query.push(item.value);
                                                queryUI.push(item.title);
                                            }
                                            this.$store.commit("widgetData/addSelect", {
                                                sensitive: selectFromStore.attentionText !== "",
                                                code: selectFromStore.code,
                                                group: selectFromStore.group,
                                                title: `${selectFromStore.title}: ${queryUI.join(", ")}`,
                                                queryUI,
                                                query
                                            });
                                        });
                                    });
                                } else if (selectFromStore.type === "autocomplete_tree") {
                                    let params = {
                                        query: value.split(",")
                                    };
                                    if (selectFromStore.code) {
                                        params.code = selectFromStore.code;
                                    }
                                    await this.$store.dispatch("widgetData/getValues", params).then(({ data: { data: response } }) => {
                                        let selected = response;
                                        let titles = selected.map(item => item.title);

                                        this.$store.commit("widgetData/addSelect", {
                                            sensitive: selectFromStore.attentionText !== "",
                                            code: selectFromStore.code,
                                            group: selectFromStore.group,
                                            title: `${selectFromStore.title}: ${titles.slice(0, 5).join(", ")}`,
                                            showMore: titles.length > 5,
                                            queryUI: titles,
                                            query: selected.map(item => item.value)
                                        });
                                    });
                                } else if (selectFromStore.type === "geo_search") {
                                    let params = {
                                        query: value.split("|")
                                    };
                                    if (selectFromStore.code) {
                                        params.code = selectFromStore.code;
                                    }
                                    await this.$store.dispatch("widgetData/getValues", params).then(({ data: { data: response } }) => {
                                        if (!response.length) {
                                            return;
                                        }

                                        response.map(item => {
                                            this.$store.commit("widgetData/addSelectGeo", {
                                                sensitive: false,
                                                code: selectFromStore.code,
                                                type: item.type,
                                                title: item.name,
                                                query: item.code
                                            });
                                        });
                                    });
                                }
                            }
                        }
                    }
                    this.$store.commit("widgetData/setUserChanged");
                }
            }
            this.$store.commit("others/setPreLoading", false);
        }
    },
    async created () {
        if (window.splitIOclient) {
            this.$store.commit("others/setTreatment", {
                key: "toggle_firmographics",
                value: window.splitIOclient.getTreatment("toggle_firmographics")
            });
        }

        await this.getConfig();
    },
    mounted () {
        if (history.scrollRestoration) {
            history.scrollRestoration = "manual";
        } else {
            window.onbeforeunload = function () {
                window.scrollTo(0, 0);
            };
        }

        window.onbeforeunload = () => {
            this.$store.dispatch("widgetData/saveSelectToLocalstorage");
        };

        window.addEventListener("beforeunload", () => {
            this.$store.dispatch("widgetData/saveSelectToLocalstorage");
        }, false);

        EventBus.$on("show-tippy-modify", (ref) => {
            setTimeout(() => {
                if (window.screen.width < 1024) {
                    let offset = ref.getBoundingClientRect().top + window.scrollY - document.querySelector("header").clientHeight - 50;
                    this.$scrollTo("body", 500, { offset });
                }

                let modifyTip = tippy(ref, {
                    placement: "top-start",
                    theme: "widget",
                    trigger: "",
                    content: "Modify here",
                    onShown (instance) {
                        setTimeout(() => {
                            instance.hide();
                        }, 2000);
                    }
                });

                modifyTip.show();
            }, 100);
        });
    }
};
</script>
